var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "major" }, [
    _c("div", { staticClass: "major-header" }, [
      _c("i", {
        ref: "backRef",
        staticClass: "iconfont icon-xiangyou",
        class: [_vm.isDirection ? "" : "mirrorRotateLevel"],
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.goBack.apply(null, arguments)
          }
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("FEE")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "major-main" }, [
      _c(
        "div",
        _vm._l(_vm.list, function(_, index) {
          return _c(
            "van-cell",
            {
              key: index,
              class: { "active-cell": index === _vm.active },
              on: {
                click: function($event) {
                  return _vm.changeSelect(index)
                }
              }
            },
            [
              _c("van-panel", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c("div", { staticClass: "item-top dis-ben" }, [
                            _c("div", [_vm._v(_vm._s(_.description))]),
                            _vm._v(" "),
                            _c("div", [_vm._v(_vm._s(_.time))])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item-bottom dis-ben" }, [
                            _c("div", [_vm._v(_vm._s(_.sat))]),
                            _vm._v(" "),
                            _c("div", [_vm._v(_vm._s(_.usd))])
                          ])
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "default",
                      fn: function() {
                        return [
                          index === _vm.active &&
                          !_vm.inpIndex && _vm.inpIndex !== 0
                            ? _c(
                                "div",
                                { key: 1, staticClass: "item-content" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "item-content-top dis-ben" },
                                    [
                                      _c("div", [
                                        _vm._v("Sats in Inscription")
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v("546 sats ≈ 0.23 USDT")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "item-content-bottom dis-ben"
                                    },
                                    [
                                      _c("div", [_vm._v("Service fee")]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v("1,000 sats ≈ 0.43 USDT")
                                      ])
                                    ]
                                  )
                                ]
                              )
                            : index === _vm.inpIndex
                            ? _c(
                                "div",
                                { key: 2, staticClass: "item-content-inp" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "item-content-inp-cy" },
                                    [_vm._v("Sat/vB")]
                                  ),
                                  _vm._v(" "),
                                  _c("cu-field", {
                                    model: {
                                      value: _vm.inpValue,
                                      callback: function($$v) {
                                        _vm.inpValue = $$v
                                      },
                                      expression: "inpValue"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "van-button",
                                    {
                                      staticStyle: { width: "100%" },
                                      on: {
                                        click: function($event) {
                                          return _vm.edit(index)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s("修改"))]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        }),
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "major-footer" },
      [
        _c(
          "van-button",
          {
            on: {
              click: function($event) {
                return _vm.confirmOrder()
              }
            }
          },
          [_vm._v("确认下单")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5700a779", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5700a779","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/InscriptionArea/confirmOrder.vue
// module id = uolG
// module chunks = 0